// src/domains/index.ts —— 组合顺序：shell → 各业务域（TD-806；影子实例已退场，TD-825）
import { dash } from './dash';
import { settings } from './settings';
import { shell } from './shell';
import { table } from './table';
import type { AdminDomain } from './types';

export const DOMAINS: readonly AdminDomain[] = [shell, table, settings, dash];
